import Component from "../core/Component";
import Scroll from "../services/Scroll";

export default class ArticleAnchors extends Component {
   constructor(element) {
      super(element);
      this.SCROLL_OFFSET = 50; // nav click top scroll offset
      this.HEADLINE_TYPE = "h2"; // headline type from which blue navigation is created DEFAULT
      // headline type detection from data-anchors-type="h2"
      if (this.element.getAttribute("data-anchors-type")) this.HEADLINE_TYPE = this.element.getAttribute("data-anchors-type");
      this.header = document.querySelector(".Header");
      this.offset = 0;
      this.titles = [];
      this.outlines = [];
      this.blueBoxHeight;
   }

   prepare() {
      window.addEventListener("load", () => {
         Scroll.on("scroll", this.scrollPosition);
         this.collectTitlesData();
         if (this.titles.length > 0) {
            this.createBlueBox();
            this.createNavigation();
            this.collectTitlesData();
            this.createAnchors();
         }
      });

      window.addEventListener("resize", () => {
         this.collectTitlesData();
         this.createAnchors();
      });
   }

   createBlueBox() {
      let box = document.createElement("div");
      box.classList.add("manual-detail__info");
      let title = document.createElement("div");
      title.classList.add("info-title");
      title.innerText = this.element.getAttribute("data-anchors-title");
      box.appendChild(title);
      let row = document.createElement("div");
      row.classList.add("row");
      box.appendChild(row);
      this.element.querySelector(".manual-detail__top").insertAdjacentHTML('afterEnd', box.outerHTML)
   }

   collectTitlesData() {
      this.titles = [];
      const titles = this.element.querySelectorAll(this.HEADLINE_TYPE);
      titles.forEach((item) => {
         let obj = [
            {
               title: item.innerText,
               top: item.getBoundingClientRect().top + window.scrollY,
            },
         ];
         let orig = this.titles;
         this.titles = [...orig, ...obj];
      });
   }

   scrollPosition = ({ offset }) => {
      this.offset = offset.y;
   };

   createNavigation() {
      const wrapper = document.querySelector(".manual-detail__info .row");
      this.titles.forEach((item) => {
         let navItem = document.createElement("div");
         navItem.classList.add("col-md-6");
         navItem.classList.add("js-anchor");
         navItem.innerText = item.title;
         wrapper.appendChild(navItem);
      });
      this.outlines = wrapper.querySelectorAll(".col-md-6.js-anchor");
   }

   createAnchors() {
      this.outlines.forEach((item, index) => {
         item.removeEventListener("click", () => this.eventListenerContent(index));
         item.addEventListener("click", () => this.eventListenerContent(index));
      });
   }

   eventListenerContent(index) {
      window.scrollTo({ top: this.titles[index].top - this.header.offsetHeight - this.SCROLL_OFFSET, behavior: "smooth" });
   }
}
